export default (router, API, store, options) => {
  const pathWithLogin = router.options.routes.find(record => record.meta.authorizationType === 'login');

  router.beforeEach((to, from, next) => {
    const pathThatRequiresAuth = to.matched.some(record => record.meta.requiresAuthentication);
    const sessionEndpoint = { endpoint: options.endpoints.session };

    if (pathThatRequiresAuth) {
      (async () => {
        await store.dispatch('authorization/checkIfUserSessionExists', sessionEndpoint);
        const isAuthenticated = store.getters['authorization/isAuthenticated'];
        if (isAuthenticated) {
          next();
        } else {
          next(pathWithLogin);
        }
      })();
    } else if (to.name === pathWithLogin.name) {
      (async () => {
        API.removeResponseInterceptor();
        await store.dispatch('authorization/checkIfUserSessionExists', sessionEndpoint);
        const isAuthenticated = store.getters['authorization/isAuthenticated'];
        if (isAuthenticated) {
          API.addResponseInterceptor();
          next(options.pathAfterLogin);
        } else {
          next();
        }
      })();
    } else {
      next();
    }
  });
};
